module.exports = __webpack_public_path__ + "static/img/bg-en.84381aea.png";